const statusIcons = {
  process: 'rt-base-circle-process-filled',
  finish: 'rt-base-circle-check-lined',
  error: 'rt-base-circle-close-lined',
  success: 'rt-base-circle-check-lined',
  cancel: 'rt-base-circle-minus-lined'
};

export default statusIcons;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/stateline/status-icons.js